import { useMemo, useState, type ReactNode } from "react";
import { defaultPeriod, periodBounds, remainingWeeks } from "@/lib/dashboard-period";
import {
  PeriodContext,
  PersonFilterContext,
  type PeriodContextValue,
  type PersonFilterContextValue,
} from "@/contexts/dashboard-filter-context";

/**
 * Provider for the sales dashboard filter layer (VIB-1093, F0.2). Holds the
 * selected period (default "this quarter", Oslo) and person (null = whole team).
 * Context objects + hooks live in dashboard-filter-context.ts.
 */
export function DashboardFilterProvider({ children }: { children: ReactNode }) {
  const [period, setPeriod] = useState(() => defaultPeriod(new Date()));
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const periodValue = useMemo<PeriodContextValue>(
    () => ({
      period,
      setPeriod,
      bounds: periodBounds(period),
      remainingWeeks: remainingWeeks(period, new Date()),
    }),
    [period],
  );

  const personValue = useMemo<PersonFilterContextValue>(
    () => ({ selectedUserId, setSelectedUserId }),
    [selectedUserId],
  );

  return (
    <PeriodContext.Provider value={periodValue}>
      <PersonFilterContext.Provider value={personValue}>
        {children}
      </PersonFilterContext.Provider>
    </PeriodContext.Provider>
  );
}
